import { h, Fragment, JSX } from 'preact'
import { Message } from '../../../../lib/intl/Message'
import { Geografi, Parti, PartiResultat } from '../../../domain'
import { Ubesvart } from '../Pastander/Ubesvart/Ubesvart'
import { PastandModul } from '../Pastander/Pastand'

import { withSectionErrorBoundary } from '../../shared/SectionErrorBoundary/SectionErrorBoundary'
import { useWidgetUrls } from '../../../routes/widget'
import { mapParti, mapPastander } from '../Pastander/Pastander'

type Props = {
  parti: Parti
  geografi: Geografi
  partiresultat: PartiResultat
  pastander: any
  widgetFooter?: JSX.Element
}

function _PastanderParti({ parti, geografi, partiresultat, pastander, widgetFooter }: Props) {
  const { partipastanderUrl } = useWidgetUrls()

  if (!pastander) {
    return null
  }

  const mappedParti = mapParti(parti, pastander)
  const mappedPartiPastander = mappedParti.pastandsvar
    ? mapPastander(mappedParti, pastander)
    : undefined

  return (
    <section
      data-widget-url={partipastanderUrl(parti, 'kommune')}
      data-valgtype={'kommune'}
      data-grunndata={parti.id}
      data-modulnavn="pastander-parti"
    >
      <Message
        as="h3"
        id="hva-mener-partiet-tittel"
        values={{ kommune: geografi.navn, kortnavn: parti.kortNavn, partinavn: parti.navn }}
      />
      <Message
        as="p"
        id="hva-mener-partiet-forklaring"
        values={{ kommune: geografi.navn, kortnavn: parti.kortNavn, partinavn: parti.navn }}
      />
      {mappedPartiPastander ? (
        <PastandModul parti={mappedParti} pastander={mappedPartiPastander} />
      ) : (
        <Ubesvart parti={mappedParti} />
      )}
      {widgetFooter}
    </section>
  )
}

export const PastanderParti = withSectionErrorBoundary(_PastanderParti)
